/**
 * 带时效性的 localStorage 操作工具
 */

/**
 * 设置带过期时间的 localStorage
 * @param {string} key - 存储的键名
 * @param {*} value - 存储的值
 * @param {number} ttlMinutes - 有效期（分钟），默认 5 分钟
 */
function setLocalWithExpiry (key, value, ttlMinutes = 5) {
  const now = new Date()
  // 设置过期时间为当前时间 + ttlMinutes 分钟
  const item = {
    value: value,
    expiry: now.getTime() + ttlMinutes * 60 * 1000 // 转换为毫秒
  }
  localStorage.setItem(key, JSON.stringify(item))
}

/**
 * 获取带过期时间的 localStorage
 * @param {string} key - 存储的键名
 * @returns {*} 成功则返回值，过期或不存在则返回 null
 */
function getLocalWithExpiry (key) {
  const itemStr = localStorage.getItem(key)
  if (!itemStr) {
    return null // 没有找到数据
  }

  try {
    const item = JSON.parse(itemStr)
    const now = new Date()

    // 检查是否已过期
    if (now.getTime() > item.expiry) {
      // 如果过期了，删除该项并返回 null
      localStorage.removeItem(key)
      return null
    }

    return item.value
  } catch (e) {
    console.error('解析 localStorage 数据失败:', e)
    localStorage.removeItem(key) // 解析失败也删除无效数据
    return null
  }
}

/**
 * 删除指定的 localStorage
 * @param {string} key - 存储的键名
 */
function removeLocal (key) {
  localStorage.removeItem(key)
}

/**
 * 清空所有 localStorage
 */
function clearAllLocal () {
  localStorage.clear()
}

// 导出所有方法
export {
  setLocalWithExpiry,
  getLocalWithExpiry,
  removeLocal,
  clearAllLocal
}
